import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { VideosListVMDispatcher } from './videos.viewModel.list';
import { VideosViewModel } from './videos.viewModel';
import { SearchBoxInput } from './components/SearchBox';
import { SortBadge } from '@client/new/components/SortBadge/SortBadge';
import { EditVideoModal } from './components/EditVideoModal';
import { Button } from '@design-system/components/button/button';
import { ColumnSchema } from '@client/new/components/StandardTable/StandardTable';

import { TableList } from './components/TableList';
import { SearchInput } from '@design-system/components/searchinput';
import { EditVideo } from './components/editVideo/EditVideo';

export const FilteringAndSorting = (
  p: Pick<VideosViewModel, 'searchText' | 'sort' | 'sortOptions'> & {
    dispatch: VideosListVMDispatcher;
  },
) => (
  <div className="flex gap-6 items-center">
    <div className="flex-1 max-w-md">
      <SearchBoxInput
        value={p.searchText}
        onChange={(payload) => p.dispatch({ type: 'searchText', payload })}
        InputProps={{
          placeholder: `Search by name`,
        }}
      />
    </div>

    <SortBadge
      items={p.sortOptions}
      value={p.sort}
      onChange={(sort) => p.dispatch({ type: 'sort', payload: sort })}
    />
  </div>
);

export const UploadButton = () => {
  return (
    <Button
      leftIcon={faPlus}
      variant="filled"
      size="large"
      color="neutral"
      className={'w-full'}
    >
      Upload
    </Button>
  );
};

export const Videos = (p: VideosViewModel) => {
  if (p.rows.length === 0) return <></>;
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between relative">
        <div className="flex gap-2 absolute top-[-60px] right-0">
          <UploadButton />
        </div>
      </div>
      <div style={{ maxWidth: '300px' }}>
        <SearchInput
          placeholder={`Search by name (${p.rows.length} videos)`}
          value={p.searchText}
          onChange={(e) =>
            p.dispatch({ type: 'searchText', payload: e.target.value })
          }
          onClear={() => p.dispatch({ type: 'searchText', payload: '' })}
        />
      </div>

      {p.editedVideo && (
        <EditVideo
          video={p.editedVideo}
          onClose={() => p.dispatch({ type: 'cancelEdit' })}
          dispatch={p.dispatch}
          submittingEdit={p.submittingEdit}
          showChangeThumbnail={p.showChangeThumbnail}
          control={p.control}
          editErrors={p.editErrors}
        />
      )}

      {p.showEditMedia && p.media && (
        <EditVideoModal
          media={p.media}
          isOpen={p.showEditMedia}
          step={p.step}
          onClose={() => p.dispatch({ type: 'editMedia', payload: false })}
          onCancel={() => p.dispatch({ type: 'cancelEdit' })}
          onUpload={console.log}
          onSaveVideo={({ file, editParams }) =>
            p.dispatch({
              type: 'setVideoParams',
              payload: { file, editParams },
            })
          }
          onSetStep={(step) => p.dispatch({ type: 'setStep', payload: step })}
          onSaveThumbnail={(time) =>
            p.dispatch({ type: 'setThumbnail', payload: time })
          }
        />
      )}

      <TableList
        rows={p.rows}
        schema={schema}
        itemHeight={84} // h + m
        itemGap={16}
      />
    </div>
  );
};

const schema: ColumnSchema[] = [
  { label: 'Name', width: 'stretchable' },
  { label: 'Content Type', width: 100, justify: 'center', maxWidth: '20%' },
  { label: 'Date created', width: 150, justify: 'center', maxWidth: '20%' },
  { label: 'Actions', width: 130, justify: 'center', maxWidth: 130 },
];
